// extracted by mini-css-extract-plugin
export var bodyRow = "_fo-d";
export var cardColumns = "_fo-e";
export var ellipsesOverflow = "_fo-2";
export var flatBottomCorners = "_fo-3";
export var flatTopCorners = "_fo-4";
export var headerActionsDropdown = "_fo-f";
export var headerBottomRow = "_fo-c";
export var headerTopRow = "_fo-b";
export var orderDetailsWrapper = "_fo-0";
export var orderInfoContainer = "_fo-1";
export var productDetails = "_fo-9";
export var productImage = "_fo-5";
export var responsiveTable = "_fo-8";
export var shipmentContainer = "_fo-a";
export var tableBottomLeft = "_fo-6";
export var tableBottomRight = "_fo-7";